import { useState, useEffect, useCallback } from 'react';
import TT from '../../src/Component/assets/logo/TT.svg';
import EVO from '../../src/Component/assets/logo/EVO.svg';
import ONTIME from '../../src/Component/assets/logo/ONTIME.svg';
import ZIPPY from '../../src/Component/assets/logo/ZIPPY.svg';
import SBAELD from '../../src/Component/assets/logo/sba.svg';
import RTELOGS from '../../src/Component/assets/logo/rtelogs.svg';
import RULER from '../../src/Component/assets/logo/RULER.svg';

import TT_LOGIN from '../../src/Component/assets/logo/TT_LOGIN.svg';
import EVO_LOGIN from '../../src/Component/assets/logo/EVO_LOGIN.svg';
import ONTIME_LOGIN from '../../src/Component/assets/logo/ONTIME_LOGIN.svg';
import ZIPPY_LOGIN from '../../src/Component/assets/logo/ZIPPY_LOGIN.svg';
import SBAELD_LOGIN from '../../src/Component/assets/logo/SBA_LOGIN.svg';
import RTE_LOGIN from '../../src/Component/assets/logo/RTE_LOGIN.svg';
import RULER_LOGIN from '../../src/Component/assets/logo/Ruler_Login.svg';
import FLEETVISION from '../../src/Component/assets/logo/FLEETVISION.svg';

export enum EProjectNames {
  TTELD = 'tteld',
  EVO = 'evoeld',
  ONTIME = 'ontime-logs',
  ZIPPY = 'zippyeld',
  UATELD = 'uateld',
  SBAELD = 'sbaeld',
  RTE = 'rtelogs',
  RULER = 'rulereld',
  FLEETVISION = 'fleetvision',
}

interface ProjectDataType {
  projectName: EProjectNames;
  title: string;
  logo: string;
  loginLogo?: string;
  baseUrl: string;
  socketUrl: string;
  color?: {
    headerBackground: string;
    headerTitleColor: string;
  };
  favicon: string;
  reportUrl: string;
}

const PROJECT_DATA: Record<EProjectNames, ProjectDataType> = {
  [EProjectNames.TTELD]: {
    projectName: EProjectNames.TTELD,
    title: 'TT ELD',
    logo: TT,
    baseUrl: 'https://addmin-api.tteld.com/api/',
    socketUrl: 'https://addmin-api.tteld.com',
    color: {
      headerBackground: '#FFBB00',
      headerTitleColor: '#1f1604',
    },
    loginLogo: TT_LOGIN,
    favicon: '/favicons/tteld.svg',
    reportUrl: 'https://report.tteld.com',
  },
  [EProjectNames.EVO]: {
    projectName: EProjectNames.EVO,
    title: 'EVO ELD',
    logo: EVO,
    baseUrl: 'https://addmin-api.evoeld.com/api/',
    socketUrl: 'https://addmin-api.evoeld.com',
    loginLogo: EVO_LOGIN,
    color: {
      headerBackground: '#06B4EA',
      headerTitleColor: '#ffffff',
    },
    favicon: '/favicons/evoeld.svg',
    reportUrl: 'https://report.evoeld.com',
  },
  [EProjectNames.ONTIME]: {
    projectName: EProjectNames.ONTIME,
    title: 'Ontime-Logs',
    logo: ONTIME,
    baseUrl: 'https://addmin-api.ontime-logs.com/api/',
    socketUrl: 'https://addmin-api.ontime-logs.com',
    loginLogo: ONTIME_LOGIN,
    color: {
      headerBackground: '#F64847',
      headerTitleColor: '#ffffff',
    },
    favicon: '/favicons/ontime.svg',
    reportUrl: 'https://report.ontime-logs.com',
  },
  [EProjectNames.ZIPPY]: {
    projectName: EProjectNames.ZIPPY,
    title: 'Zippy ELD',
    logo: ZIPPY,
    baseUrl: 'https://addmin-api.zippyeld.com/api/',
    socketUrl: 'https://addmin-api.zippyeld.com',
    loginLogo: ZIPPY_LOGIN,
    color: {
      headerBackground: '#0D63E4',
      headerTitleColor: '#ffffff',
    },
    favicon: '/favicons/zippy.svg',
    reportUrl: 'https://report.zippyeld.com',
  },
  [EProjectNames.SBAELD]: {
    projectName: EProjectNames.SBAELD,
    title: 'SBA ELD',
    logo: SBAELD,
    baseUrl: 'https://front-api.sbaeld.com/api/',
    socketUrl: 'https://front-api.sbaeld.com',
    color: {
      headerBackground: '#48B5C5',
      headerTitleColor: '#fff',
    },
    loginLogo: SBAELD_LOGIN,
    favicon: '/favicons/sbaeld.svg',
    reportUrl: 'https://report.sbaeld.com',
  },
  [EProjectNames.RTE]: {
    projectName: EProjectNames.RTE,
    title: 'RTE Logs',
    logo: RTELOGS,
    baseUrl: 'https://front-api.rtelogs.com/api/',
    socketUrl: 'https://front-api.rtelogs.com',
    color: {
      headerBackground: '#1A3E6A',
      headerTitleColor: '#fff',
    },
    loginLogo: RTE_LOGIN,
    favicon: '/favicons/rtelogs.svg',
    reportUrl: 'https://report.rtelogs.com',
  },
  [EProjectNames.RULER]: {
    projectName: EProjectNames.RULER,
    title: 'Ruler ELD',
    logo: RULER,
    baseUrl: 'https://front-api.rulereld.com/api/',
    socketUrl: 'https://front-api.rulereld.com',
    color: {
      headerBackground: '#FF9503',
      headerTitleColor: '#1f1604',
    },
    loginLogo: RULER_LOGIN,
    favicon: '/favicons/ruler.svg',
    reportUrl: 'https://report.rulereld.com',
  },
  [EProjectNames.UATELD]: {
    projectName: EProjectNames.UATELD,
    title: 'UAT ELD',
    logo: TT,
    baseUrl: 'https://uat.tteld.com/api/',
    socketUrl: 'https://uat.tteld.com',
    color: {
      headerBackground: '#FFBB00',
      headerTitleColor: '#1f1604',
    },
    loginLogo: TT_LOGIN,
    favicon: '/favicons/tteld.svg',
    reportUrl: 'https://uat.tteld.com',
  },
  [EProjectNames.FLEETVISION]: {
    projectName: EProjectNames.FLEETVISION,
    title: 'Fleet Vision',
    logo: FLEETVISION,
    baseUrl: 'https://addmin-api.fleetvision.co/api/',
    socketUrl: 'https://addmin-api.fleetvision.co',
    color: {
      headerBackground: '#5263f7',
      headerTitleColor: '#ffffff',
    },
    loginLogo: FLEETVISION,
    favicon: '/favicons/tteld.svg',
    reportUrl: 'https://report.fleetvision.co',
  },
};

function detectProject(): EProjectNames {
  // const forcedProject = (process.env.REACT_APP_PROJECT_NAME || '').toLowerCase();
  // if (
  //   forcedProject &&
  //   Object.values(EProjectNames).includes(forcedProject as EProjectNames)
  // ) {
  //   return forcedProject as EProjectNames;
  // }
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes('uat')) return EProjectNames.UATELD;
  if (hostname.includes('tteld')) return EProjectNames.TTELD;
  if (hostname.includes('evo')) return EProjectNames.EVO;
  if (hostname.includes('ontime')) return EProjectNames.ONTIME;
  if (hostname.includes('zippy')) return EProjectNames.ZIPPY;
  if (hostname.includes('sbaeld')) return EProjectNames.SBAELD;
  if (hostname.includes('rte')) return EProjectNames.RTE;
  if (hostname.includes('ruler')) return EProjectNames.RULER;
  if (hostname.includes('fleetvision')) return EProjectNames.FLEETVISION;

  // development
  return EProjectNames.UATELD;
}

export function useProjectData() {
  const [project, setProject] = useState<EProjectNames>(detectProject());
  const [data, setData] = useState<ProjectDataType>(PROJECT_DATA[project]);

  useEffect(() => {
    setData(PROJECT_DATA[project]);
  }, [project]);

  const updateProject = useCallback((newProject: EProjectNames) => {
    if (PROJECT_DATA[newProject]) {
      setProject(newProject);
    }
  }, []);

  return {
    project,
    projectData: data,
    setProject: updateProject,
  };
}
